import React, { Component, Fragment } from 'react';
import { observer, PropTypes as MobxPropTypes } from 'mobx-react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import { uniqueId } from 'lodash';

import { modelOf } from '../../../prop-types';
import Product from '../../../models/Product';
import ProductCard from '../../product/ProductCard';
import ProductListStyle from '../../../types/ProductListStyle';
import ProductImpressions from '../../product/ProductImpressions';
import CategoryHeader from '../CategoryHeader';

const CardWrapper = ({ children }) => (
  <Col xs={6} sm={4} md={3} lg={3} xl={'1-5'}>
    {children}
  </Col>
);

const LargeCardWrapper = ({ children }) => (
  <Col xs={6} sm={6} md={4} lg={4} xl={3}>
    {children}
  </Col>
);

const CategoryNameWrapper = ({ children }) => <Col xs={12}>{children}</Col>;

@observer
class ProductList extends Component {
  render() {
    const {
      products,
      name,
      style,
      completeListingLink,
      productParams
    } = this.props;

    let Wrapper;
    let CategoryWrapper = CategoryNameWrapper;
    let large;
    switch (style) {
      case ProductListStyle.CARD_LARGE:
        Wrapper = LargeCardWrapper;
        large = true;
        break;
      default:
      case ProductListStyle.CARD:
        Wrapper = CardWrapper;
        large = false;
    }

    let productMainCategoryId = null;
    const productCols = products.map((product, index) => {
      const { cardSettings, showCategoryHeaders } = this.props;
      const mergedCardSettings = {
        productListView: true,
        product,
        position: index + 1,
        listName: name,
        large,
        modelMargin: true,
        productParams,
        ...cardSettings
      };

      const productCardComponent = (
        <Wrapper key={product.id}>
          <ProductCard {...mergedCardSettings} />
        </Wrapper>
      );

      if (
        productMainCategoryId !== product.main_category_id &&
        showCategoryHeaders
      ) {
        productMainCategoryId = product.main_category_id;

        return (
          <Fragment key={uniqueId(product.main_category_id)}>
            <CategoryWrapper key={uniqueId(product.main_category_id)}>
              <CategoryHeader breadcrumb={product.mainCategory.breadcrumbs} />
            </CategoryWrapper>
            {productCardComponent}
          </Fragment>
        );
      }

      return productCardComponent;
    });

    const productsArray = products.slice();
    if (completeListingLink && productCols.length > 0) {
      productCols[productCols.length - 1] = (
        <Wrapper key="_completeListingLink">{completeListingLink}</Wrapper>
      );
      // Drop the last product impression because it is not shown.
      productsArray.pop();
    }

    return (
      <div className="ProductList">
        <ProductImpressions listName={name} products={productsArray} />
        <Row>{productCols}</Row>
      </div>
    );
  }
}

ProductList.propTypes = {
  style: PropTypes.oneOf(Object.values(ProductListStyle)),
  products: MobxPropTypes.observableArrayOf(modelOf(Product)),
  name: PropTypes.string,
  completeListingLink: PropTypes.node,
  showCategoryHeaders: PropTypes.bool
};

export default ProductList;



// WEBPACK FOOTER //
// ./src/components/product-list/ProductList/index.jsx